import React from 'react'

const CategoryLine = ({ id, nom }) => {
  return (
    <p key={id} className="cursor-pointer">{nom}</p>
  )
}

export default CategoryLine